import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";


export default function Login() {
  const { handleLogin, isLoading } = useAuth();
  const navigate = useNavigate();


  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorLocal, setErrorLocal] = useState(null);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorLocal(null);
    const ok = await handleLogin(username, password);
    if (ok) {
      navigate("/dashboard");
    } else {
      setErrorLocal("Usuario o contraseña inválidos");
    }
  };


  return (
    <div className="flex justify-center items-center h-screen bg-gray-100 px-4">
      <form onSubmit={handleSubmit} className="bg-white p-12 rounded-2xl shadow-2xl w-full" style={{maxWidth: 480}}>
        <h2 className="text-4xl font-bold mb-8 text-center text-gray-800">Iniciar sesión</h2>


        <input
          type="text"
          placeholder="Usuario"
          className="border-2 border-gray-300 p-4 w-full mb-4 rounded-lg text-lg focus:border-blue-500 focus:outline-none"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Contraseña"
          className="border-2 border-gray-300 p-4 w-full mb-6 rounded-lg text-lg focus:border-blue-500 focus:outline-none"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button disabled={isLoading} className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-4 rounded-lg w-full text-xl font-semibold transition-colors">
          {isLoading ? "Ingresando..." : "Entrar"}
        </button>


        {errorLocal && <p className="text-red-600 text-lg mt-4 text-center font-medium">{errorLocal}</p>}
      </form>
    </div>
  );
}
